/* jshint esversion: 9 */
const TokenKey = 'x-token';

// 获取token
export function getToken() {
	return uni.getStorageSync(TokenKey);
}

// 设置token
export function setToken(token) {
	return uni.setStorageSync(TokenKey, token);
}

// 删除token
export function removeToken() {
	return uni.removeStorageSync(TokenKey);
}
